







































import { versions } from 'process';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { VDialog, VCard, VCardTitle, VIcon, VCardText, VDataTable, VAutocomplete, VCardActions, VSpacer, VBtn } from 'vuetify/lib';
import { Model } from '@/modules/neovehicle/models';
import { FamilyVersionManagement } from '@/modules/neovehicle/models/family';

@Component
export default class extends Vue {
  @Prop()
  public isOpen: boolean;

  @Prop()
  public versions: FamilyVersionManagement[];

  @Prop()
  public models: Model[];

  @Prop()
  public currentFamilyVersion!: FamilyVersionManagement;

  public isOpenInternal = false;
  public idFamilyVersion = 0;

  public headersStep1 = [
    { text: 'Código', value: 'id', sortable: false },
    { text: 'Código Origem', value: 'idorigin', sortable: false },
    { text: 'Descrição do Modelo', value: 'name', sortable: false },
    { text: 'Bandeira', sortable: false },
  ];

  public created() {
    this.isOpenInternal = this.isOpen;
  }

  public handleChangeFamilyVersion(idFamilyVersion: number) {
    this.$emit('change', idFamilyVersion);
  }

  public handleCancel() {
    this.$emit('cancel');
  }

  public handleMove() {
    if (this.models.length) {
      this.$emit('move-selected', this.idFamilyVersion);
    } else {
      this.$emit('move-all', this.currentFamilyVersion, this.idFamilyVersion);
    }
  }
}
